module.exports = __webpack_public_path__ + "img/hr-green-hairy-grass-13.a3fa1b2c.png";